import { Icon } from "web/components"

import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/outline"

const controlClasses =
  "invisible cursor-pointer rounded-md bg-white bg-opacity-80 group-hover:visible"

export default function TileControls({
  isEditMode,
  handleTileSettings,
  handleEditMode,
  handleSave,
  handleOnHide,
  handleBreakout,
}) {
  return (
    <div className="ml-auto flex items-center justify-center gap-2.5">
      {!isEditMode && (
        <>
          {handleBreakout && (
            <Icon
              width="24px"
              height="24px"
              outline="true"
              name="arrow-top-right-on-square"
              className={controlClasses}
              onClick={handleBreakout}
            />
          )}
          {handleEditMode && (
            <Icon
              name="pencil"
              width="24px"
              height="24px"
              outline
              className={controlClasses}
              alt="edit text"
              onClick={handleEditMode}
            />
          )}

          {handleTileSettings && (
            <Icon
              name="cog"
              width="24px"
              height="24px"
              outline="true"
              className={controlClasses}
              alt="settings"
              onClick={handleTileSettings}
            />
          )}
          <Icon
            name="x-mark"
            width="24px"
            height="24px"
            outline="true"
            className={controlClasses}
            alt="hide"
            onClick={handleOnHide}
          />
        </>
      )}
      {isEditMode && (
        <div className="-mt-3 flex gap-2.5">
          <CheckCircleIcon
            onClick={handleSave}
            alt="save text"
            className="h-6 w-6 cursor-pointer rounded-md bg-white bg-opacity-80 text-blue-500"
          />
          <XCircleIcon
            onClick={handleEditMode}
            alt="cancel edit"
            className="h-6 w-6 cursor-pointer rounded-md bg-white bg-opacity-80 text-red-500"
          />
        </div>
      )}
    </div>
  )
}
